/**
 * Stripe.js LAZY (recuperación de pago + Configuración → Método de pago).
 * La publishable key es segura de exponer (por diseño de Stripe); vive en
 * VITE_STRIPE_PUBLISHABLE_KEY (Railway, servicio del frontend — por ambiente).
 * Sin la env: getStripe() resuelve null y la UI degrada con un mensaje (el
 * resto del app no carga Stripe.js jamás — solo los flujos de billing).
 */
import { loadStripe, type Stripe } from '@stripe/stripe-js';

let promise: Promise<Stripe | null> | null = null;

export function getStripe(): Promise<Stripe | null> {
  if (!promise) {
    const key = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;
    // .catch → null: si js.stripe.com no carga (red/adblock/CSP), los flujos
    // degradan al mensaje de "no disponible" en vez de cachear una promesa
    // rechazada (unhandled rejection y el form en limbo). Se resetea el caché
    // para que un reintento posterior pueda cargar.
    promise = key
      ? loadStripe(key).catch((e) => {
          console.warn('Stripe.js no cargó:', e);
          promise = null;
          return null;
        })
      : Promise.resolve(null);
  }
  return promise;
}
